import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

export interface TableProfilePayload {
  dataset_name: string;
  table_name: string;
  created_at_cutoff_months: number;
  top_values_limit: number;
}

export interface TableProfileColumnInfo {
  column_name: string;
  data_type: string;
  top_values: { value: string | number | boolean; count: number }[];
}

export interface TableProfileResponse {
  columns: TableProfileColumnInfo[];
  [key: string]: unknown;
}

export const fetchTableProfile = async (
  payload: TableProfilePayload,
): Promise<TableProfileResponse> => {
  try {
    const token = await getBearerToken();

    if (!token) {
      throw new Error("No token found");
    }

    const response = await fetch(API_ENDPOINTS.BIGQUERY_TABLE_PROFILE, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (response.status >= 400) {
      const errorText = await response.text();
      throw new Error(
        `Failed to fetch table profile: ${response.status} - ${errorText}`,
      );
    }

    return await response.json();
  } catch (error) {
    logError(error as Error, "Error in fetchTableProfile");
    throw error;
  }
};
